import _ from "lodash";
import { getUserCoursesV2CountQuery } from "./CourseQueries";
import client from "lib/apolloClient/client";

export const getUserCoursesV2CountFromCache = variables => {
  let queryData = {};
  try {
    queryData = client.readQuery({
      query: getUserCoursesV2CountQuery,
      variables,
    });
  } catch (e) {
    console.warn(e);
    return {};
  }
  return _.get(queryData, "node", {});
};
